<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs>
        <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg5>
            <h2>Bot OnePlatform</h2>
          </v-flex>
          <v-flex xs11 lg6 class="text-end"> </v-flex>
        </v-layout>
        <!-- <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg pb-2">
              <EmployeeOneID />
            </v-card>
          </v-flex>
        </v-layout> -->
        <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title class="ml-2"
                >{{ $t("onechat.groupconsent") }}<v-spacer></v-spacer>
                <v-row justify="end" d-flex>
                  <v-col cols="12" sm="12" md="7" lg="7" class="mr-2 d-flex">
                    <v-btn
                      color="#077893"
                      style="height: 100%"
                      size="x-large"
                      class="white--text mr-2"
                      @click="Fn_CreateGropsent"
                    >
                      <v-icon dark> mdi-plus</v-icon>
                      {{ $t("search.creategroup") }}
                    </v-btn>
                    <v-text-field
                      clearable
                      outlined
                      dense
                      v-model="Search"
                      append-icon="mdi-magnify"
                      :label="$t('consentlist.searchgroup')"
                      color="#077893"
                      hide-details
                      style="width: 100%"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-flex lg12>
                <v-data-table
                  :search="Search"
                  :loading="tableload"
                  :loading-text="$t('overlay.load')"
                  :headers="headers"
                  :items="AllService"
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  hide-default-footer
                  @page-count="pageCount = $event"
                >
                  <template v-slot:[`item.Id`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div>
                          <v-icon
                            v-on="on"
                            v-bind="attrs"
                            style="cursor: pointer"
                            @click="handleCopyClick(item.Id)"
                            color="#077893"
                            :key="iconState[item.Id] || 'copy'"
                            class="icon-transition"
                          >
                            {{
                              iconState[item.Id] === "copied"
                                ? "mdi mdi-check"
                                : "mdi mdi-content-copy"
                            }}
                          </v-icon>
                        </div>
                      </template>
                      <span>Copy</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.NameTh`]="{ item }">
                    <div
                      v-if="$t('default') === 'th'"
                      class="text-truncate"
                      style="max-width: 300px"
                    >
                      {{ item.NameTh }}
                    </div>
                    <div v-else class="text-truncate" style="max-width: 300px">
                      {{ item.NameEng }}
                    </div>
                  </template>
                  <template v-slot:[`item.CreatedBy`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.CreatedBy == "" ? "-" : item.CreatedBy }}
                    </div>
                    <div v-else>{{ item.NameEng }}</div>
                  </template>
                  <template v-slot:[`item.CreatedAt`]="{ item }">
                    <div v-if="$t('default') === 'th'">
                      {{ item.CreatedAt ? formatDate(item.CreatedAt) : "-" }}
                    </div>
                    <div v-else>
                      {{ item.UpdatdeAtEng || "-" }}
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn color="#077893" outlined @click="Fn_Details(item)">{{
                      $t("consentlist.detail")
                    }}</v-btn>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12>
                <div class="text-center pt-2">
                  <v-pagination
                    :total-visible="7"
                    class="pt-2 pb-2"
                    circle
                    color="#077893"
                    v-model="page"
                    :length="pageCount"
                    prev-icon="mdi-menu-left"
                    next-icon="mdi-menu-right"
                  >
                  </v-pagination>
                </div>
              </v-flex>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- <SearchConsentLogOnechatIndex /> -->
        <!-- <SendBotOnePlatFormDetail /> -->
        <!-- <LogOnechat /> -->
      </v-container>
      <div v-if="isLoading">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>
<script>
import EmployeeOneID from "@/views/Admin/Consent/OnePlatform/EmployeeOneID.vue";
import EmployeeCMP from "@/views/Admin/Consent/OnePlatform/EmployeeCMP.vue";
import SendOnechatDetail from "@/views/Admin/Consent/OnePlatform/SendOnePlatformDetail.vue";
import SendBotOnePlatFormDetail from "@/views/Admin/BotOnePlatform/SendBotOnePlatFormDetail.vue";
import authorization from "@/functions/authorization.js";
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import moment from "moment";
import "moment/locale/th"; // สำหรับภาษาไทย

export default {
  components: {
    EmployeeOneID,
    EmployeeCMP,
    SendOnechatDetail,
    SendBotOnePlatFormDetail,
    OverlaySearch,
  },
  name: "BotOnePlatformIndex",
  data() {
    return {
      tab: null,
      iconState: {},
      items: [this.$t("onechat.new1")],
      tableload: false,
      isLoading: true,
      Search: "",
      search: "",
      AllService: [
        // {
        //   Id: "e85fbcd3-3df7-48d3-afc3-15a06c7g29c8",
        //   NameEng: "Somchai Jaidee",
        //   NameTh: "สมชาย ใจดี",
        //   QrcodeName: "ทดสอบ Qr2",
        //   Type: "General",
        //   UpdatdeAt: "31 มี.ค. 2025 12:00:00",
        //   UpdatdeAtEng: "31 Mar 2025 12:00:00",
        // },
        // {
        //   Id: "f96gcd44-4ef8-49e4-bfd4-26b17d8h30d9",
        //   NameEng: "Somsri Rakdee",
        //   NameTh: "สมศรี รักดี",
        //   QrcodeName: "ทดสอบ Qr3",
        //   Type: "General",
        //   UpdatdeAt: "31 มี.ค. 2025 13:00:00",
        //   UpdatdeAtEng: "31 Mar 2025 13:00:00",
        // },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      // Add any data properties you need here
    };
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "-"; // หรือ return ค่าเริ่มต้นอื่นๆ ตามต้องการ
      return moment(dateString).locale("th").format("DD MMM YYYY HH:mm:ss");
    },
    handleCopyClick(id) {
      // ตั้งค่าสถานะเป็น 'copied' สำหรับไอคอนนี้
      this.Fn_CopyDetail(id);
      this.$set(this.iconState, id, "copied");

      // หลังจาก 2 วินาที เปลี่ยนกลับเป็นไอคอนเดิม
      setTimeout(() => {
        this.$set(this.iconState, id, "copy");
      }, 1200);
    },
    async Fn_CopyDetail(Id) {
      await navigator.clipboard.writeText(Id);
    },
    async Fn_GetAllBot() {
      var biz_id = this.$cookies.get("BusinessId");
      var Name = "";
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/GroupSend/${biz_id}?Name=${Name}`,
          {
            headers: {
              Authorization: "Bearer " + auth,
              "ngrok-skip-browser-warning": "true",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.AllService = response.data.Message;
          this.tableload = false;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.tableload = false;
        });
    },
    Fn_CreateGropsent() {
      this.$router.push({ path: "/bot-add" });
    },
    Fn_Details(item) {
      if (item) {
        this.$store.dispatch("SET_DATA_BOT_ONEPLATFORM", item);
        this.$router.push({ path: "bot-detail" });
      }
    },
    onSearch() {
      // this.Search = this.search;
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "ID",
          align: "center",
          value: "Id",
          width: "20%",
          sortable: false,
        },
        {
          text: "ชื่อ",
          value: "GroupName",
          align: "center",
          width: "20%",
          sortable: false,
        },
        {
          text: "วันที่สร้าง",
          align: "center",
          value: "CreatedAt",
          width: "20%",
          sortable: false,
        },
        {
          text: "ผู้สร้าง",
          align: "center",
          value: "CreatedBy",
          width: "20%",
          sortable: false,
        },
        {
          text: this.$i18n.t("policyForm.select"),
          value: "action",
          sortable: false,
          width: "20%",
          align: "center",
        },
      ];
    },
  },
  mounted() {
    this.Fn_GetAllBot();
    // Add any mounted lifecycle hooks you need here
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.icon-transition {
  transition: all 0.3s ease;
}
</style>
